export default function hexToHSL(hex: string) {
    if (!hex) {
        return "";
    }

    // Parse r, g, b values
    const r = Number.parseInt(hex.substring(1, 3), 16) / 255;
    const g = Number.parseInt(hex.substring(3, 5), 16) / 255;
    const b = Number.parseInt(hex.substring(5, 7), 16) / 255;

    // Find the maximum and minimum values of r, g, and b
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h: number;

    let s: number;

    let l: number = (max + min) / 2;

    if (max === min) {
        // achromatic
        h = 0;
        s = 0;
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                h = 0;
                break;
        }
        h /= 6;
    }

    // Convert to degrees, percentage
    h = Math.round(h * 360);
    s = Math.round(s * 100);
    l = Math.round(l * 100);

    return `${h} ${s}% ${l}%`;
}
